import { Component, ViewChild, ElementRef, TemplateRef, Inject, OnInit, OnDestroy, Input, Output, EventEmitter,NgZone, ChangeDetectorRef} from '@angular/core';
import _ from 'lodash';
import {moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { DeviceDetectorService } from "ngx-device-detector";
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { ExportService } from '../../services/export.service';
import { BroadCastService } from '../../services/broadcast.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { CodeFileItem, FertilityCalendarItem, GroupTypeMember, HerdFertilityCalendar, FertilityCalendarEnrollmentFrequency, PerformanceContext } from '../../interfaces/mysynch.interfaces';

import {CdkDragDrop, CdkDragStart,CdkDragEnd,CdkDragMove, CdkDropList, CdkDrag, moveItemInArray,transferArrayItem} from '@angular/cdk/drag-drop';
import { LongPressDirective } from '../../directives/long-press.directive';


interface DayCell{
    dOP?: number;
    dOPType?: string;
    dOPLabel?: string;
    weekNumber?: number;
    dayOfWeek?: number;
    timeOfDay?: 'AM' | 'PM';
    listId?: string;
    connectedTo?: string[];
    fertilityItems?: FertilityCalendarItem[];
    isLongPressed: boolean;
}

interface FertilityCalendarRow {
    weekNumber: number;
    weekNumberLabel: string;
    amDayCells: DayCell[];
    pmDayCells: DayCell[];
}

interface MobileActionItem{
    weekNumber: number;
    weekDay: string;
    timeOfDay: string;
    dayCell?: DayCell;
}
interface DeleteProgramActionItem{
    item: FertilityCalendarItem;
    shouldDelete: boolean;
}

@Component({
    standalone: false,
    selector: 'fertility-calendar',
    templateUrl: '../app/content-components/fertility-calendar/fertility-calendar.view.html',
    styleUrls: ['../app/content-components/fertility-calendar/fertility-calendar.style.css']
    })
export class FertilityCalendar implements OnInit , OnDestroy{

    @ViewChild('procedureList', { read: ElementRef }) procedureList!: ElementRef<HTMLElement>;
    @ViewChild('mobileActionList', { read: TemplateRef }) mobileActionListTemplate!: TemplateRef<any>;
    @ViewChild('mobileActionAdd', { read: TemplateRef }) mobileActionAddTemplate!: TemplateRef<any>;
    @ViewChild('mobileActionSort', { read: TemplateRef }) mobileActionSortTemplate!: TemplateRef<any>;
    @ViewChild('mobileActionDelete', { read: TemplateRef }) mobileActionDeleteTemplate!: TemplateRef<any>;
    @ViewChild('mobileActionNone', { read: TemplateRef }) mobileActionNoneTemplate!: TemplateRef<any>;

    @Input() numberOfDIM:number = 182;
    @Input() set calendarListItems(items: FertilityCalendarItem[]) {
            if(!this.MSF.isNullish(items)){
                this._calendarListItems = items;
            }
    }
    get calendarListItems(): FertilityCalendarItem[] {
        return this._calendarListItems;
    }
    @Input() set calendar(calendar: HerdFertilityCalendar) {
        this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF.getActiveHerd(), 'herdId', null));
        //console.log('Calendar is being set in FertilityCalendar component:', calendar);
        const noCalendar = _.isNull(this._calendar) 
        if(!noCalendar){
            
            if(_.get(calendar,'fertilityCalendarItems.length', 0) > 0){
                this.synchronizeCalendarItemsWithCalendar(calendar);
            }

            const differentCalendar = this.isDifferentCalendar(this._calendar, calendar)
            const differentCalendarDates = this.hasDifferentCalendarDates(this._calendar, calendar)
            const differentLactationGroup = this.hasDifferentLactationGroup(this._calendar, calendar);
            const differentStartDOP = this.hasDifferentStartDOP(this._calendar, calendar)
            const differentEnrollmentFrequency = this.hasDifferentEnrollmentFrequency(this._calendar, calendar);
            const differentFertilityCalendarItems = this.hasDifferentFertilityCalendarItems(this._calendar, calendar);
    
            const requiresReload = noCalendar || differentCalendar || differentCalendarDates || differentLactationGroup || differentStartDOP || differentEnrollmentFrequency || differentFertilityCalendarItems;
            
            this._calendar = _.cloneDeep(calendar);
        
            if(requiresReload){
                // make sure the program action view is closed before reloading the calendar 
                if(!_.isNull(this.currentMobileActionItem)){
                    this.closeProgramActionView(); 
                }
                this.perfMetricSvc.startTiming('Component:FertilityCalendar:Render');
                this.loadCalendar().then(() => {
                    this.perfMetricSvc.endTiming("component",'Component:FertilityCalendar:Render', this.performanceContext);
                });
                if(differentLactationGroup || differentStartDOP || differentEnrollmentFrequency || differentFertilityCalendarItems){
                    this.calendarInputChanged.emit(this._calendar.fertilityCalendarItems);
                }
            }
        }else{
            this._calendar = _.cloneDeep(calendar);
            this.perfMetricSvc.startTiming('Component:FertilityCalendar:Render');
            this.loadCalendar().then(() => {
                this.perfMetricSvc.endTiming("component",'Component:FertilityCalendar:Render', this.performanceContext);
            });
        }
    }
    get calendar(): HerdFertilityCalendar {
        return this._calendar;
    }
    @Input() isExporting: boolean = false;

    @Output() calendarItemAdded: EventEmitter<[FertilityCalendarItem, FertilityCalendarItem[]]> = new EventEmitter<[FertilityCalendarItem, FertilityCalendarItem[]]>();
    @Output() calendarItemRemoved: EventEmitter<[FertilityCalendarItem[], FertilityCalendarItem[]]> = new EventEmitter<[FertilityCalendarItem[], FertilityCalendarItem[]]>();
    @Output() calendarItemMoved: EventEmitter<[FertilityCalendarItem, FertilityCalendarItem[]]> = new EventEmitter<[FertilityCalendarItem, FertilityCalendarItem[]]>();
    @Output() calendarItemSorted: EventEmitter<FertilityCalendarItem[]> = new EventEmitter<FertilityCalendarItem[]>();
    @Output() calendarInputChanged: EventEmitter<FertilityCalendarItem[]> = new EventEmitter<FertilityCalendarItem[]>();

   
    private performanceContext: PerformanceContext | null = null;
    private calendarItemListId:string = 'procedureList';
    
    private _calendar: HerdFertilityCalendar | null = null;
   private _calendarListItems: FertilityCalendarItem[] = [];
   private defaultStartDOP: number = 42;
   
   private lactGroups: GroupTypeMember[] = [];
   
   private heiferGroupTypeMemberId = 3;
   
   
   private breedingItemsTypes: string[] = ['TAI']
   private noDOPRangeTypes: string[] = ['VWP','HD','TC','MGA'];
   private heiferDOPType:string = "";
   private cowBeforeBreedingDOPType:string = "";
   private cowAfterBreedingDOPType:string = "";
   private currentBeforeBreedingDOPType: string = "";
   private currentEnrollmentFrequencyRangeFactor: number = 0;
   
   private fertilityCalendarItemSortOrder: string[] = ['weekNumber','dayOfWeek', 'timeOfDay', 'dayCellIndex'];
   private fertilityCalendarItemSortOrderDirection: string[] = ['asc','asc','asc','asc'];
   

    _:any = _;
    
    loading: boolean = true;
    isMobile: boolean;
    isDragging: boolean = false;
    showCalendarItemListInfoTooltip = false;

    isDraggingFromCalendarItemList = false;
    draggingCalendarItemListId: number | null = null;
    
    numberOfRows: number = 53;
    dOPStarts: number[] = [];
    headerRowDayLabels: string[] = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    weekNumberLabels: string[] = [];
    dimLabels: string[] = [];
    

    allCalendarRows: FertilityCalendarRow[] = [];
    printedCalendarRows: FertilityCalendarRow[] = [];

    allListIds: string[] = [];
    calendarListItemIds: string[] = [];

    currentTempFertilityCalendarItemId: number = 100000;

    currentMobileActionView: string = "none";
    previousMobileActionView: string = "none";
    currentMobileActionItem: MobileActionItem | null = null;
    currentOrderPositions: number[] = [];
    currentOrderPosition: number = 0;

    //-------------------------------------------------
    // Mobile only
    //-------------------------------------------------
    selectedProgramActionOption: FertilityCalendarItem = null;
    
    selectedProgramActionConfig:any = {
        controlId:"selectedProgramAction",
        labelProperty:"",
        valueProperty:"programAction",
        orderByField:[""],
        orderByDirection: [""],
        placeholder: "Select Program Action",
        virtualScroll: true
    }
    onSelectedProgramActionChange(fertilityCalendarItemOption:FertilityCalendarItem): void {
        this.selectedProgramActionOption = fertilityCalendarItemOption;
    }

    sortActionOptions: FertilityCalendarItem[] = [];
    selectedSortProgramActionOption: FertilityCalendarItem = null;
    
    selectedSortProgramActionConfig:any = {
        controlId:"selectedSortProgramAction",
        labelProperty:"",
        valueProperty:"programAction",
        orderByField:[""],
        orderByDirection: [""],
        placeholder: "Select Program Action",
        virtualScroll: true
    }
    onSelectedSortProgramActionChange(fertilityCalendarItemOption:FertilityCalendarItem): void {
        this.selectedSortProgramActionOption = fertilityCalendarItemOption;
    }

    deleteProgramActionItems: DeleteProgramActionItem[] = [];
   
    //-------------------------------------------------

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(DeviceDetectorService) private deviceDetectorSvc:DeviceDetectorService,
                @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService,
                @Inject(ExportService) private exportService: ExportService,
                @Inject(BroadCastService) private broadcastSvc:BroadCastService,    
                @Inject(NgZone) private ngZone:NgZone,
                @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
                @Inject(PerformanceMetricsService) private perfMetricSvc:any,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService){
            this.isMobile = this.deviceDetectorSvc.isMobile();
    }

    private isDifferentCalendar(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
         const newCalendarId = _.get(newCalendar, 'id');
         const oldCalendarId = _.get(oldCalendar, 'id');

         return !_.isEqual(newCalendarId, oldCalendarId) || _.isEmpty(newCalendar?.fertilityCalendarItems);
    }

    private hasDifferentCalendarDates(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
        const newCalendarStartDate = _.get(newCalendar, 'startDate');
        const newCalendarEndDate = _.get(newCalendar, 'endDate');
        const oldCalendarStartDate = _.get(oldCalendar, 'startDate');
        const oldCalendarEndDate = _.get(oldCalendar, 'endDate');
        return !_.isEqual(newCalendarStartDate, oldCalendarStartDate) || !_.isEqual(newCalendarEndDate, oldCalendarEndDate);
    }
    private hasDifferentLactationGroup(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
        const newCalendarLactationGroup = _.get(newCalendar, 'lactationGroup');
        const oldCalendarLactationGroup = _.get(oldCalendar, 'lactationGroup');
        return !_.isEqual(newCalendarLactationGroup, oldCalendarLactationGroup);
    }
    private hasDifferentStartDOP(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
        const newCalendarStartDOP = _.get(newCalendar, 'startDOP', this.defaultStartDOP);
        const oldCalendarStartDOP = _.get(oldCalendar, 'startDOP', this.defaultStartDOP);
        return !_.isEqual(newCalendarStartDOP, oldCalendarStartDOP);
    }
    private hasDifferentEnrollmentFrequency(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
        const newCalendarEnrollmentFrequency = _.get(newCalendar, 'enrollmentFrequencyCode');
        const oldCalendarEnrollmentFrequency = _.get(oldCalendar, 'enrollmentFrequencyCode');
        return !_.isEqual(newCalendarEnrollmentFrequency, oldCalendarEnrollmentFrequency);
    }
    private hasDifferentFertilityCalendarItems(oldCalendar: HerdFertilityCalendar | null, newCalendar: HerdFertilityCalendar | null): boolean {
        const newCalendarItems = _.get(newCalendar, 'fertilityCalendarItems', []);
        const oldCalendarItems = _.get(oldCalendar, 'fertilityCalendarItems', []);

        // compare length first for a quick check
        if(newCalendarItems.length !== oldCalendarItems.length){
            return true;
        }
        const sortedNewCalendarItems = _.sortByOrder(newCalendarItems, ['id'], ['asc']);
        const sortedOldCalendarItems = _.sortByOrder(oldCalendarItems, ['id'], ['asc']);

        const hadDifferentItems =  sortedNewCalendarItems.some((item, index) => {
            const originalItem = sortedOldCalendarItems[index];
            
            // Compare only the specific properties you care about
            return item.id !== originalItem.id ||
                item.dOP !== originalItem.dOP ||
                item.weekNumber !== originalItem.weekNumber ||
                item.dayOfWeek !== originalItem.dayOfWeek ||
                item.timeOfDay !== originalItem.timeOfDay ||
                item.dayCellIndex !== originalItem.dayCellIndex;
            });
       // console.log(`Comparing fertility calendar items, had different items: ${hadDifferentItems}`);
        return hadDifferentItems;
    }

    private shouldShowDOPRange(totalItemsInDayCell: FertilityCalendarItem[]): boolean {
        return !_.isEmpty(totalItemsInDayCell) && (_.get(totalItemsInDayCell, 'length', 0) > 1 || !_.some(totalItemsInDayCell, (item) => _.includes(this.noDOPRangeTypes, item.dOPType)));
    }

    private synchronizeCalendarItemsWithCalendar(newCalendar: HerdFertilityCalendar): void {
        const newCalendarItems = _.get(newCalendar, 'fertilityCalendarItems', []);
        _.forEach(newCalendarItems, (item) => {
            let existingCalendarItem = _.find(this._calendar?.fertilityCalendarItems, (existingItem) =>{
                 if(_.isEqual(existingItem.dOP, item.dOP)
                    && _.isEqual(existingItem.weekNumber, item.weekNumber)
                    && _.isEqual(existingItem.dayOfWeek, item.dayOfWeek)
                    && _.isEqual(existingItem.timeOfDay, item.timeOfDay)
                    && _.isEqual(existingItem.dayCellIndex, item.dayCellIndex)){
                        return true;
                    }
            });
            if(existingCalendarItem){
                // update existing item properties
               _.set(existingCalendarItem, 'id', item.id);
               _.set(existingCalendarItem, 'herdFertilityCalendarItemId', item.herdFertilityCalendarItemId);
               _.set(existingCalendarItem, 'herdFertilityCalendarId', item.herdFertilityCalendarId);
            }

            const dayCell = this.getDayCell(item);
            if(dayCell){
                const existingItemInDayCell = _.find(dayCell.fertilityItems, (existingItem) =>{
                 if(_.isEqual(existingItem.dOP, item.dOP)
                    && _.isEqual(existingItem.weekNumber, item.weekNumber)
                    && _.isEqual(existingItem.dayOfWeek, item.dayOfWeek)
                    && _.isEqual(existingItem.timeOfDay, item.timeOfDay)
                    && _.isEqual(existingItem.dayCellIndex, item.dayCellIndex)){
                        return true;
                    }
                });
                if(existingItemInDayCell){
                    // update existing item properties
                     _.set(existingItemInDayCell, 'id', item.id);
                    _.set(existingItemInDayCell, 'herdFertilityCalendarItemId', item.herdFertilityCalendarItemId);
                    _.set(existingItemInDayCell, 'herdFertilityCalendarId', item.herdFertilityCalendarId);
                }
            }

        });
    }
    


    private buildWeekNumberLabels(){
        this.weekNumberLabels = _.times(this.dOPStarts.length, (dOPStartIndex) => `${dOPStartIndex}`);
    }


    private getFirstCalendarItem(): FertilityCalendarItem | null {
        if(_.isEmpty(this._calendar?.fertilityCalendarItems)){
            return null;
        }
        return _.first(_.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection));
    }

   

    private buildDayCellsForWeek(weekNumber:number, timeOfDay: 'AM' | 'PM'): DayCell[]{
        let dayCells: DayCell[] = [];
        for(let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++){

            let cellItems = _.filter(this._calendar.fertilityCalendarItems, (item) => item.weekNumber === weekNumber && item.dayOfWeek === dayOfWeek);
            let items = _.filter(cellItems, (item) => item.timeOfDay === timeOfDay);
            items = _.sortByOrder(items, ['dayCellIndex'], ['asc']);

            
            let dayCell: DayCell = {
                // dOP info will set later in the loading process
                dOP: 0,
                dOPType: '',
                dOPLabel: '',
                weekNumber: weekNumber,
                dayOfWeek: dayOfWeek,
                timeOfDay: timeOfDay,
                listId: `${weekNumber}-${dayOfWeek}-${timeOfDay}`,
                connectedTo: [],
                fertilityItems: items,
                isLongPressed: false
            };
          
            dayCells.push(dayCell);

        }

        
        return dayCells;
    }

    private buildCalendarRows(){
        this.allCalendarRows = [];
        for(let rowIndex = 0; rowIndex < this.numberOfRows; rowIndex++){
            const weekNumber = rowIndex + 1;
            let calendarRow:FertilityCalendarRow = {
                weekNumber: weekNumber,
                weekNumberLabel: `${weekNumber}`,
                amDayCells: this.buildDayCellsForWeek(weekNumber,'AM'),
                pmDayCells: this.buildDayCellsForWeek(weekNumber,'PM')
            };

            this.allCalendarRows.push(calendarRow);
        }
    }

    private buildListIds(){
        this.allListIds = ['procedureList'];

        const dayCells: DayCell[] = _.flattenDeep(_.map(this.allCalendarRows, (row) => _.union(row.amDayCells, row.pmDayCells)));
        const dayCellListIds: string[]= _.map(dayCells, (dayCell) => dayCell.listId);
        this.allListIds = this.allListIds.concat(dayCellListIds);

        this.calendarListItemIds = _.rest(this.allListIds);

        _.forEach(this.allCalendarRows, (row) => {
            _.forEach(row.amDayCells, (amDayCell) => {
                amDayCell.connectedTo = _.without(this.allListIds, amDayCell.listId);
                
            });
            _.forEach(row.pmDayCells, (pmDayCell) =>{
                 pmDayCell.connectedTo = _.without(this.allListIds, pmDayCell.listId);
            });
        });
    }
    private setCurrentBeforeBreedingDOPType():void{
        const heiferGroupMember = _.get(_.find(this.lactGroups, {id: this.heiferGroupTypeMemberId}), 'groupMember', null);
        if(heiferGroupMember && _.get(this._calendar,'lactationGroup') === heiferGroupMember){
            this.currentBeforeBreedingDOPType = this.heiferDOPType;
        }else{
            this.currentBeforeBreedingDOPType = this.cowBeforeBreedingDOPType;
        }
    }
    

    private getNextTempFertilityCalendarItemId(): number {
        // capture current temp id and then increment for next call
        const currentId = this.currentTempFertilityCalendarItemId;
        this.currentTempFertilityCalendarItemId += 1;
        return currentId;
    }

    private setPrintedCalendarRows(): void {
        // first clear the printed calendar rows
        this.printedCalendarRows = [] as FertilityCalendarRow[];
        const lastCalendarItem = _.last(_.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection));
        if(lastCalendarItem){
            this.printedCalendarRows = _.filter(this.allCalendarRows, (row) => row.weekNumber <= lastCalendarItem.weekNumber);
        }
    }

    private loadCalendar = (): Promise<void> =>{
        return new Promise<void>((resolve, reject) => {
            const codeFileEnrollmentFrequencies = this.MSF.getCodeFileSubsetWithParsedDetailsJson(_.filter(_.get(this.MSF,'lists.codeFile',[]), {codeType: 'CALENROLLFRQS'})) as CodeFileItem[];
            this.currentEnrollmentFrequencyRangeFactor = _.get(_.find(codeFileEnrollmentFrequencies, {code: this._calendar?.enrollmentFrequencyCode}), 'detailsJson.rangeFactor', 0);

            this.buildCalendarRows();
        
            this.buildListIds();

            const lactGroupMembers = _.filter(_.get(this.MSF,'lists.groupTypeMembers',[]),{groupTypeCode:"LACTGROUP-SETCSV"}) as GroupTypeMember[]; 
            this.lactGroups = _.sortByOrder(_.map(lactGroupMembers, (member)=>{
                                                                return {
                                                                    id: member.id,
                                                                    groupTypeCode: member.groupTypeCode,
                                                                    groupMember: member.groupMember,
                                                                    groupMemberCode: member.groupMemberCode,
                                                                    sequence: member.sequence,
                                                                };
                                                            }) as GroupTypeMember[]
                                            , ['sequence'], ['asc']);
        
            


            const codeFileDOPTypes = _.filter(this.MSF.lists.codeFile, {codeType: 'DOPTYPES'}) as CodeFileItem[];
            this.heiferDOPType = _.get(_.find(codeFileDOPTypes, {code: 'HEIFER'}), 'codeValue', '');
            this.cowBeforeBreedingDOPType = _.get(_.find(codeFileDOPTypes, {code: 'COWBEFOREBREED'}), 'codeValue', '');
            this.cowAfterBreedingDOPType = _.get(_.find(codeFileDOPTypes, {code: 'COWAFTERBREED'}), 'codeValue', '');
            this.setCurrentBeforeBreedingDOPType();
            this.calculateAllDOPAndDOPLabels();

            this.setPrintedCalendarRows();
            resolve();
        });
    }

    private removeCalendarDayCellItem(item: FertilityCalendarItem, dayCell: DayCell)
    {
        dayCell.fertilityItems = _.reject(dayCell.fertilityItems, (ci) => _.isEqual(ci.id, item.id));
    }

    private getFormattedCalendarName(calendarName: string): string {
        return this.MSF.getCleanedString(calendarName).replace(/\s+/g, '_');
    }
   
    onPrintCalendar(): void {
        window.print();
    }

    onExportCalendarAsImage(): void {
            this.ngZone.run(()=>{
                this.isExporting = true;
                this.cdr.detectChanges();
                 // Defer the export to the next tick
                setTimeout(() => {
                    if(this._calendar){
                        this.exportService.exportPageAsPng( `${this.getFormattedCalendarName(this._calendar.name)}.png`, "#mainAppContainer", "Generating Calendar Image...").then(()=>{
                            this.isExporting = false;
                            this.broadcastSvc.exportingMsg(this.isExporting);
                        }).catch((err)=>{
                            this.log.error('Error exporting calendar as image: ' + err);
                            this.isExporting = false;   
                            this.broadcastSvc.exportingMsg(this.isExporting); 
                        });
                    }
                }, 0);
            });
        }

    
    toggleCalendarListItemTooltip(): void {
        this.showCalendarItemListInfoTooltip = !this.showCalendarItemListInfoTooltip;
    }
    showCalendarListItemTooltip(show: boolean): void {
        this.ngZone.run(() => {
            this.showCalendarItemListInfoTooltip = show;
        });
    }

    // Calendar Item List Drag Handlers

    onDragStartCalendarListItem(event: CdkDragStart, item: FertilityCalendarItem): void {
        this.isDragging = true;
        this.isDraggingFromCalendarItemList = true;
        this.draggingCalendarItemListId = item.id; // use a real id, not text
     //   console.log('Drag started item from CalendarItemList:', item);
    }

    onDragEndCalendarListItem(event: CdkDragEnd, item: FertilityCalendarItem): void {
        this.isDraggingFromCalendarItemList = false;
        this.draggingCalendarItemListId = null;
          this.isDragging = false;
       // console.log('Drag ended for item from CalendarItemList:', item);
    }
    calendarListEnterPredicate = (drag: any, drop: any) => {
        // allow only drags that originated from the CalendarItemList itself
        return drag.dropContainer?.id === 'procedureList';
    };

    onMoveCalendarListItem(event: CdkDragMove<FertilityCalendarItem[]>): void {
        // You can use event.pointerPosition to get the current pointer position
    }
   

    // Calendar Day Cell Drag Handlers

    onDragStartDayCell(event: CdkDragStart): void {
        this.isDragging = true;
       // console.log('Dragging item from day cell:', event);
    }
    onDragEndCalendarDayCell(event: CdkDragEnd): void {
       // console.log('Drag ended for item from day cell:', event);   
    }
    private getDayCell(item: FertilityCalendarItem): DayCell {
        const dayCell = _.find(_.flattenDeep(_.map(this.allCalendarRows, (row) => row.amDayCells.concat(row.pmDayCells))), {weekNumber: item.weekNumber, dayOfWeek: item.dayOfWeek, timeOfDay: item.timeOfDay});
        return dayCell;
    }
    private getOppositeDayCell(dayCell: DayCell): DayCell  {
        const oppositeTimeOfDay = dayCell.timeOfDay === 'AM' ? 'PM' : 'AM';
        const oppositeDayCell = _.find(_.flattenDeep(_.map(this.allCalendarRows, (row) => row[oppositeTimeOfDay === 'AM' ? 'amDayCells' : 'pmDayCells'])), {weekNumber: dayCell.weekNumber, dayOfWeek: dayCell.dayOfWeek});
        return oppositeDayCell!;
    }

      private nearestBeforeBreedingItem(item: FertilityCalendarItem): FertilityCalendarItem | undefined {
        const precedingItems = _.filter(this._calendar!.fertilityCalendarItems, (calendarItem) => {
                                        return calendarItem.weekNumber < item.weekNumber || 
                                               (calendarItem.weekNumber === item.weekNumber && calendarItem.dayOfWeek < item.dayOfWeek);
                                                
                                    });
        const sortedPrecedingItems = _.sortByOrder(precedingItems, this.fertilityCalendarItemSortOrder,['desc','desc','desc','desc']);
        
        // is there a breeding item that comes after this item in the week of the item
         return _.find(sortedPrecedingItems, (precedingItem) => _.includes(this.breedingItemsTypes, _.get(precedingItem, 'text')));

    }

    private nearestAfterBreedingItem(item: FertilityCalendarItem): FertilityCalendarItem | undefined {
        const followingItems = _.filter(this._calendar!.fertilityCalendarItems, (calendarItem) => {
                                        return calendarItem.weekNumber > item.weekNumber || 
                                               (calendarItem.weekNumber === item.weekNumber && calendarItem.dayOfWeek > item.dayOfWeek);
                                    });
        const sortedFollowingItems = _.sortByOrder(followingItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
        // is there a breeding item that comes after this item in the week of the item
        return _.find(sortedFollowingItems, (followingItem) => _.includes(this.breedingItemsTypes, _.get(followingItem, 'text')));
    }
    

    private applyDOPAndDOPLabelToDayCellSet(
        fertRows: FertilityCalendarRow[], 
        dOPStart: number, 
        dOPType: string, 
        startFertItem: FertilityCalendarItem, 
        endFertItem?: FertilityCalendarItem  // Optional end boundary
    ): void {
        _.forEach(fertRows, (row) => {
            const dayPairs = _.zip(row.amDayCells, row.pmDayCells);
            
            _.forEach(dayPairs, ([amDayCell, pmDayCell], dayIndex) => {
                const currentDayOfWeek = dayIndex + 1; // Convert to 1-indexed
                
                // ✅ Clear boundary check - only process within start/end range
                if (!this.isDayWithinRange(row.weekNumber, currentDayOfWeek, startFertItem, endFertItem)) {
                    return; // Skip this day if outside range
                }
                
                // Only process day cells that have fertility items
                if (!_.isEmpty(amDayCell.fertilityItems) || !_.isEmpty(pmDayCell.fertilityItems)) {
                    
                    // Calculate days difference from the start item
                    const weekDiff = row.weekNumber - startFertItem.weekNumber;
                    const dayDiff = currentDayOfWeek - startFertItem.dayOfWeek!;
                    const totalDaysDiff = (weekDiff * 7) + dayDiff;
                    
                    let currentDOP: number;
                    
                    // Special handling for breeding items (start from DOP 1, but skip the breeding day itself)
                    if (_.includes(this.breedingItemsTypes, startFertItem.text)) {
                        if (totalDaysDiff <= 0) {
                            return; // Skip breeding day and days before it
                        }
                        currentDOP = totalDaysDiff; // Days after breeding: 1, 2, 3, etc.
                    } else {
                        currentDOP = dOPStart + totalDaysDiff;
                    }
                    let showDOPRange = true;
                    // if there are only one item in both am and pm cells and the item is a no range type then we don't want to show the DOP range in the label
                    if (_.sum([_.size(amDayCell.fertilityItems), _.size(pmDayCell.fertilityItems)]) === 1){
                        let item = _.first(_.compact(_.union(amDayCell.fertilityItems, pmDayCell.fertilityItems)));
                        showDOPRange = !(item && _.includes(this.noDOPRangeTypes, _.get(item, 'text')));     
                    }
                    
                    
                    // Apply DOP to both AM and PM cells if they have items
                    this.applyDOPToCell(amDayCell, currentDOP, dOPType, showDOPRange);
                    this.applyDOPToCell(pmDayCell, currentDOP, dOPType, showDOPRange);
                }
            });
        });
    }

    private isDayWithinRange(
        weekNumber: number, 
        dayOfWeek: number, 
        startItem: FertilityCalendarItem, 
        endItem?: FertilityCalendarItem
    ): boolean {
        // Check if day is after start item
        const isAfterStart = weekNumber > startItem.weekNumber || 
                            (weekNumber === startItem.weekNumber && dayOfWeek >= startItem.dayOfWeek);
        
        if (!endItem) {
            return isAfterStart; // No end boundary, just check start
        }
        
        // Check if day is before or equal to end item
        const isBeforeEnd = weekNumber < endItem.weekNumber || 
                        (weekNumber === endItem.weekNumber && dayOfWeek <= endItem.dayOfWeek);
        
        return isAfterStart && isBeforeEnd;
    }

     private getDayCellDOPLabel(dOP: number, dOPType: string, showRange:boolean=true): string {
        let dOPLabelSuffix = '';
        if(!_.isEqual(dOPType, this.cowAfterBreedingDOPType) && this.currentEnrollmentFrequencyRangeFactor > 0 && showRange){
             dOPLabelSuffix = `-${dOP+ this.currentEnrollmentFrequencyRangeFactor}`;
        }
        return `${dOPType}=${dOP}${dOPLabelSuffix}`;
    }


    private applyDOPToCell(dayCell: DayCell, dop: number, dopType: string, showDOPRange:boolean=true): void {
            const newDOPLabel = this.getDayCellDOPLabel(dop, dopType, showDOPRange);
            _.set(dayCell, 'dOP', dop);
            _.set(dayCell, 'dOPType', dopType);
            _.set(dayCell, 'dOPLabel', newDOPLabel);
            
            _.forEach(dayCell.fertilityItems, (item) => {
                _.set(item, 'dOP', dop);
                _.set(item, 'dOPType', dopType);
                _.set(item, 'dOPLabel', newDOPLabel);
                
                let itemInCalendar = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
                if(itemInCalendar){
                    _.set(itemInCalendar, 'dOP', dop);
                    _.set(itemInCalendar, 'dOPType', dopType);
                    _.set(itemInCalendar, 'dOPLabel', newDOPLabel);
                }
            });
    }

    private clearAllDOPAndDOPlables(): void {
        _.forEach(this.allCalendarRows, (row) => {
            _.forEach(row.amDayCells, (amDayCell) => {
                _.set(amDayCell, 'dOP', null);
                _.set(amDayCell, 'dOPType', null);
                _.set(amDayCell, 'dOPLabel', null);
                _.forEach(amDayCell.fertilityItems || [], (item) => {
                    _.set(item, 'dOP', null);
                    _.set(item, 'dOPType', null);
                    _.set(item, 'dOPLabel', null);
                }
                );
            });
            _.forEach(row.pmDayCells, (pmDayCell) => {
                _.set(pmDayCell, 'dOP', null);
                _.set(pmDayCell, 'dOPType', null);
                _.set(pmDayCell, 'dOPLabel', null);
                _.forEach(pmDayCell.fertilityItems || [], (item) => {
                    _.set(item, 'dOP', null);
                    _.set(item, 'dOPType', null);
                    _.set(item, 'dOPLabel', null);
                }
                );
            });
        });
    }
    private calculateAllDOPAndDOPLabels(): void {
        // first clear all existing DOP and DOP labels
        this.clearAllDOPAndDOPlables();
       
         const fertilityCalendarRowsWithItems = _.filter(this.allCalendarRows, (row) => {
                                                    const amCellsWithItems = _.filter(row.amDayCells, (cell) => !_.isEmpty(cell.fertilityItems));
                                                    const pmCellsWithItems = _.filter(row.pmDayCells, (cell) => !_.isEmpty(cell.fertilityItems));
                                                    return !_.isEmpty(amCellsWithItems) || !_.isEmpty(pmCellsWithItems);
                                                });
        const allFertilityCalendarItems =  _.sortByOrder(_.flatten(_.map(_.flattenDeep(_.map(fertilityCalendarRowsWithItems, (row) => row.amDayCells.concat(row.pmDayCells)))
                                            , (dayCell) => dayCell.fertilityItems))
                                            , this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
                                                        
        const breedingItems = _.filter(allFertilityCalendarItems, (item) => _.includes(this.breedingItemsTypes, item.text));

        // if there is only one item on the calendar , treat it the same regardless
        if(_.size(allFertilityCalendarItems) === 1){
            const firstItem = _.first(allFertilityCalendarItems);
            if (firstItem) {
               const row = _.first(fertilityCalendarRowsWithItems);
                // if this item is a VWP then we don't want to show the DOP range in the lebel
                const showDOPRange = !_.includes(this.noDOPRangeTypes, firstItem.text);

               let firstItemDayCellAM = _.find(row?.amDayCells, {listId: `${firstItem.weekNumber}-${firstItem.dayOfWeek}-AM`});
               let firstItemDayCellPM = _.find(row?.pmDayCells, {listId: `${firstItem.weekNumber}-${firstItem.dayOfWeek}-PM`});
               this.applyDOPToCell(firstItemDayCellAM, _.get(this._calendar, 'startDOP', this.defaultStartDOP), this.currentBeforeBreedingDOPType, showDOPRange);
               this.applyDOPToCell(firstItemDayCellPM, _.get(this._calendar, 'startDOP', this.defaultStartDOP), this.currentBeforeBreedingDOPType, showDOPRange);
               
            }
            return;
        }

        if(_.isEmpty(breedingItems)){
           const firstItem = _.first(allFertilityCalendarItems);
            if (firstItem) {
                this.applyDOPAndDOPLabelToDayCellSet(
                    fertilityCalendarRowsWithItems,
                    _.get(this._calendar, 'startDOP', this.defaultStartDOP),
                    this.currentBeforeBreedingDOPType,
                    firstItem
                    // No end item - process to the end
                );
            }
        }else{
             const firstBreedingItem = _.first(breedingItems);
            const firstItem = _.first(allFertilityCalendarItems);
            
            //Process items before first breeding item
            if (firstItem) {
                this.applyDOPAndDOPLabelToDayCellSet(
                    fertilityCalendarRowsWithItems,
                    _.get(this._calendar, 'startDOP', this.defaultStartDOP),
                    this.currentBeforeBreedingDOPType,
                    firstItem,
                    firstBreedingItem  // End at first breeding item
                );
            }
            
            //Process each breeding segment
            _.forEach(breedingItems, (breedingItem, index) => {
                const nextBreedingItem = _.at(breedingItems, index + 1)[0];
                
                this.applyDOPAndDOPLabelToDayCellSet(
                    fertilityCalendarRowsWithItems,
                    1, // Start from DOP 1 for after breeding
                    this.cowAfterBreedingDOPType,
                    breedingItem,
                    nextBreedingItem  // End at next breeding item (or undefined for last segment)
                );
            });

        }
    }

    addFertilityCalendarItemToCalendar(fertilityCalendarItem: FertilityCalendarItem, dayCell: DayCell, timeOfDay: 'AM' | 'PM', dayCellIndex: number): void {
         const newItem: FertilityCalendarItem = {
                id: this.getNextTempFertilityCalendarItemId(),
                herdId: this._calendar.herdId,
                herdFertilityCalendarItemId: null, // this id will be assigned right before saving.
                herdFertilityCalendarId: this._calendar.id,
                herdFertilityCalendarItemListId: fertilityCalendarItem.id,
                class: fertilityCalendarItem.class,
                text: fertilityCalendarItem.text,
                description: fertilityCalendarItem.description,
                dayOfWeek: dayCell.dayOfWeek,
                dOP: dayCell.dOP,
                dOPType: dayCell.dOPType,
                weekNumber: dayCell.weekNumber,
                timeOfDay: timeOfDay,
                dayCellIndex: dayCellIndex
            };

            const destArray = dayCell.fertilityItems;

            // Insert where the user dropped
            destArray.splice(dayCellIndex, 0, newItem);
            
            this._calendar!.fertilityCalendarItems.push(newItem);
            
            this.setPrintedCalendarRows();
            this.calculateAllDOPAndDOPLabels();
            // update the dayCellIndex for all items in the cell after reorder
            _.forEach(destArray, (item, index) => {
                _.set(item, 'dayCellIndex', index);
                var calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
                if(calendarItem){
                    _.set(calendarItem, 'dayCellIndex', index);
                }
            });
            this._calendar!.fertilityCalendarItems = _.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
         
            this.calendarItemAdded.emit([newItem, this._calendar!.fertilityCalendarItems]);
    }

    
    onDropCalendarDayCell(event: CdkDragDrop<FertilityCalendarItem[]>, dayCell: DayCell, timeOfDay: 'AM' | 'PM'): void {
 
        const droppedItem: FertilityCalendarItem = event.item.data;
        const sourceContainer = event.previousContainer;
        const targetContainer = event.container;
        if (_.isEqual(sourceContainer.id, this.calendarItemListId)) {
            // Item dragged from the CalendarItemList
            this.addFertilityCalendarItemToCalendar(droppedItem, dayCell, timeOfDay, event.currentIndex);
        } else {
             if(_.isEqual(sourceContainer.id, targetContainer.id)){
                // Item reordered within the same day cell
                moveItemInArray(targetContainer.data, event.previousIndex, event.currentIndex);
                // update the dayCellIndex for all items in the cell after reorder
                _.forEach(targetContainer.data, (item, index) => {
                    _.set(item, 'dayCellIndex', index);
                    var calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
                    if(calendarItem){
                        _.set(calendarItem, 'dayCellIndex', index);
                    }
                });
                this._calendar!.fertilityCalendarItems = _.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);    
                // console.log('Item reordered within same day cell:', dayCell, 'timeOfDay:', timeOfDay, 'event:', event);
                // console.log('Updated items in day cell:', targetContainer.data);
                this.calendarItemSorted.emit(targetContainer.data);
            } else {
                // Item dragged from another day cell
                
                _.set(droppedItem, 'dayOfWeek', dayCell.dayOfWeek);
                _.set(droppedItem, 'weekNumber', dayCell.weekNumber);
                _.set(droppedItem, 'timeOfDay', timeOfDay);
                _.set(droppedItem, 'listId', dayCell.listId);
                _.set(droppedItem, 'dayCellIndex', event.currentIndex);
                
                transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
                const calendarFertilityItemIndex = _.findIndex(this._calendar!.fertilityCalendarItems, {id: droppedItem.id});
                if(calendarFertilityItemIndex !== -1){
                    this._calendar!.fertilityCalendarItems[calendarFertilityItemIndex] = droppedItem;
                }
                 
                this.setPrintedCalendarRows();
                this.calculateAllDOPAndDOPLabels();
                // update the dayCellIndex for all items in the cell after reorder
                _.forEach(event.container.data, (item, index) => {
                    _.set(item, 'dayCellIndex', index);
                    var calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
                    if(calendarItem){
                        _.set(calendarItem, 'dayCellIndex', index);
                    }
                });
                _.forEach(event.previousContainer.data, (item, index) => {
                    _.set(item, 'dayCellIndex', index);
                    var calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
                    if(calendarItem){
                        _.set(calendarItem, 'dayCellIndex', index);
                    }
                });
                this._calendar!.fertilityCalendarItems = _.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
             
                this.calendarItemMoved.emit([droppedItem, this._calendar!.fertilityCalendarItems]);
             }
            
        }
        
            
       this.isDragging = false;
       // console.log('Item placed in day cell:', dayCell, 'timeOfDay:', timeOfDay, 'event:', event);
    }

    removeCalendarItemsFromCalendar(items: FertilityCalendarItem[], dayCell: DayCell): void {
        items.forEach(item => {
            this.removeCalendarDayCellItem(item, dayCell);
            const calendarItemIndex = _.findIndex(this._calendar!.fertilityCalendarItems, {id: item.id});
            if(calendarItemIndex !== -1){
                this._calendar!.fertilityCalendarItems.splice(calendarItemIndex, 1);
            }
        });
        
        this.setPrintedCalendarRows();
        this.calculateAllDOPAndDOPLabels();
        // recalculate the dayCellIndex for remaining items in the cell after removal
        dayCell.fertilityItems.forEach((cellItem, index) => {
            _.set(cellItem, 'dayCellIndex', index);
            var calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: cellItem.id});
            if(calendarItem){
                _.set(calendarItem, 'dayCellIndex', index);
            }
        });

        this._calendar!.fertilityCalendarItems = _.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);

        this.calendarItemRemoved.emit([items,  this._calendar!.fertilityCalendarItems]);
    }

    onCalendarDayCellItemClick(item: FertilityCalendarItem, dayCell: DayCell): void {
        // console.log('Clicked calendar day cell item:', item);
        if(this.isDragging || this.calendar.isArchived || this.calendar.isTemplate){
           // console.log('... but ignoring click because a drag is in progress.');
            return;
        }

        this.removeCalendarItemsFromCalendar([item], dayCell);

    }
    getMobileActionTemplate(view:string): any {
    switch(view) {
        case 'list':
            return this.mobileActionListTemplate;
        case 'add':
            return this.mobileActionAddTemplate;
        case 'sort':
            return this.mobileActionSortTemplate;
        case 'delete':
            return this.mobileActionDeleteTemplate;
        default:
            return "none";
        }
    }
    setMobileActionView(view: string): void {
        this.previousMobileActionView = _.isEqual(view,"none") ? "none" : this.currentMobileActionView;
        this.currentMobileActionView = this.getMobileActionTemplate(view);
    }
    
    // Long Press Handlers 
    onCalendarDayCellLongPress(event: any, dayCell: DayCell): void {
        // console.log('Long pressed calendar day cell item:', item);
        if(this.isDragging || this.calendar.isArchived || this.calendar.isTemplate){
            return;
        }
  
        
         if(_.isNull(this.currentMobileActionItem)) {
            this.initializeProgramActionView(dayCell);
        }else{
            this.clearProgramActionsViewState();
            this.initializeProgramActionView(dayCell);
        }
    }

    initializeProgramActionView(dayCell: DayCell): void {

        dayCell.isLongPressed = true;

        this.currentMobileActionItem = {
            weekNumber: dayCell.weekNumber,
            weekDay: this.MSF.getMySynchStringDayOfWeek(dayCell.dayOfWeek!),
            timeOfDay: dayCell.timeOfDay!,
            dayCell: dayCell
        } as MobileActionItem;
        //  console.log('>>> COMPONENT: onCalendarItemLongPress called', item);
        this.setMobileActionView('list'); 
    }

    clearProgramActionsViewState(): void {
        this.clearProgramActionViewState();
        this.currentMobileActionItem.dayCell.isLongPressed = false;
        this.currentMobileActionItem = null;
    }

    onCalendarItemLongPress(event: any, item: FertilityCalendarItem, dayCell: DayCell): void {
        // console.log('Long pressed calendar item:', item);
        if(this.isDragging || this.calendar.isArchived || this.calendar.isTemplate){
            return;
        }
        if(_.isNull(this.currentMobileActionItem)) {
            this.initializeProgramActionView(dayCell);
        }else{
            this.clearProgramActionsViewState();
            this.initializeProgramActionView(dayCell);
        }
       
    }


    initializeAddProgramActionItem(): void {
        this.selectedProgramActionOption = _.first(this.calendarListItems);

        this.currentOrderPositions = _.times(this.currentMobileActionItem?.dayCell.fertilityItems.length + 1 || 0, (index) => index + 1);
        this.currentOrderPosition = _.last(this.currentOrderPositions) || 1;
    }

    clearProgramActionViewState():void{
        // add action state
        this.selectedProgramActionOption = null;
        this.currentOrderPositions = [];
        this.currentOrderPosition = 1;
        // sort action state
        this.sortActionOptions = [];
        this.selectedSortProgramActionOption = null;
    
        // delete action state 
        this.deleteProgramActionItems = [];
    }

    goBackToProgramActionList(): void {
        this.clearProgramActionViewState();
        this.setMobileActionView('list');
    }

    closeProgramActionView(): void {
        this.clearProgramActionsViewState();
        this.setMobileActionView('none');
    }

    showAddProgramActionView(): void {
        this.initializeAddProgramActionItem();
        this.setMobileActionView('add');
    }
    
    addSelectedProgramActionToCalendar(): void {
        // Handle adding item to calendar
        // You might want to show a day/time selector here
        console.log('Mobile add item:', this.selectedProgramActionOption, 'to calendar at position', this.currentOrderPosition);
        this.addFertilityCalendarItemToCalendar(this.selectedProgramActionOption, this.currentMobileActionItem!.dayCell, this.currentMobileActionItem!.timeOfDay as 'AM' | 'PM', this.currentOrderPosition - 1);
        this.currentOrderPositions = _.times(this.currentMobileActionItem?.dayCell.fertilityItems.length + 1 || 0, (index) => index + 1);
        this.currentOrderPosition = _.last(this.currentOrderPositions) || 1;
    }

    onSelectedOrderPositionChange(position: number): void {
        this.currentOrderPosition = position;
    }

    initializeSortProgramAction(): void {
        const dayCellItems = this.currentMobileActionItem?.dayCell.fertilityItems || [];
        this.sortActionOptions = dayCellItems;
        this.selectedSortProgramActionOption = _.first(this.sortActionOptions) || null;
    }

    showSortProgramActionView(): void {
        this.initializeSortProgramAction();
        this.setMobileActionView('sort');
    }

    sortSelectedProgramActionInCalendar(direction: 'up' | 'down'): void {
        const dayCell = this.currentMobileActionItem.dayCell;
        const items = dayCell.fertilityItems;
        
        const currentIndex = _.findIndex(items, {id: this.selectedSortProgramActionOption.id});
        const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
        
        if (newIndex < 0 || newIndex >= items.length) return;
        
        // Remove from old position
        const [movedItem] = items.splice(currentIndex, 1);
        
        // Insert at new position
        items.splice(newIndex, 0, movedItem);
        
        // Update indices
        _.forEach(items, (item, index) => {
            item.dayCellIndex = index;
            const calendarItem = _.find(this._calendar!.fertilityCalendarItems, {id: item.id});
            if (calendarItem) {
                calendarItem.dayCellIndex = index;
            }
        });
        
        // Force change detection
        dayCell.fertilityItems = [...items];
        this._calendar!.fertilityCalendarItems = _.sortByOrder(this._calendar!.fertilityCalendarItems, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
        
        this.calendarItemSorted.emit(items);
    }

    initializeDeleteProgramAction(): void {
        const dayCellItems = this.currentMobileActionItem?.dayCell.fertilityItems || [];
        _.forEach(dayCellItems, (item) => {
            const deleteProgramActionItem = {
                item: item,
                shouldDelete: false
            } as DeleteProgramActionItem;
            this.deleteProgramActionItems.push(deleteProgramActionItem);
        });       
    }

    showDeleteProgramActionView(): void {
        this.initializeDeleteProgramAction();
        this.setMobileActionView('delete');
    }

    deleteSelectedProgramActionsFromCalendar(): void {
        const itemsToDelete = this.deleteProgramActionItems.filter(i => i.shouldDelete).map(i => i.item);
        this.removeCalendarItemsFromCalendar(itemsToDelete, this.currentMobileActionItem.dayCell);
        this.deleteProgramActionItems = _.reject(this.deleteProgramActionItems, (i) => i.shouldDelete);
    }



    


    ngOnInit() {
        this.MSF.ready(() => {
            // leaving herd change logic here in case this component will get its own data in future
            this.loading = false;
        });
    }

    ngOnDestroy() {
        this.calendarItemAdded.complete();
        this.calendarItemRemoved.complete();
        this.calendarItemMoved.complete();
        this.calendarItemSorted.complete();
        this.calendarInputChanged.complete();
        this.performanceContext = null;
    }
}